export default __webpack_public_path__ + "static/media/VICTORIA.988c1167.svg";